var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CheckBox',{attrs:{"is-disabled":_vm.isDisabled,"true-text":"payed","false-text":"onCredit","model-form":_vm.modelForm,"model-name":_vm.modelName,"do-action":_vm.doAction,"column-size":_vm.columnSize,"md-size":_vm.mdSize}})}
var staticRenderFns = []

export { render, staticRenderFns }